<template>
  <div class="article_page">
    <div class="article_content" v-if="isPc">
      <p class="violet article-explain" style="">您的帖子提交后将由管理员进行审核，预计时间在1个工作日内，请在「我的发帖」里关注状态</p>
      <div class="form_item">
        <label>标题<span>*</span>：</label>
        <div class="form_input">
          <el-input class="title_input" v-model="form.title" :maxlength="50" placeholder="请输入标题(最多 50 个字)"></el-input>
        </div>
      </div>
      <div class="form_item">
        <label>简介<span>*</span>：</label>
        <div class="form_input">
          <el-input class="introduction_input" type="textarea" :maxlength="100" resize="none" v-model="form.Introduction" placeholder="请输入简介"></el-input>
        </div>
      </div>
      <div class="form_item">
        <label>正文<span>*</span>：</label>
        <div class="form_input">
        <WEditor :defaultText="form.textContent" :richText.sync="form.textContent"></WEditor>
        </div>
      </div>
      <div class="form_item">
        <label>产品标签<span>*</span>：</label>
        <div class="form_input">
        <el-select v-model="form.productArray" multiple placeholder="选择对应的产品标签">
          <el-option v-for="(item,index) in productTagList" :key="index" :label="item.text" :value="item.value">
          </el-option>
        </el-select>
        </div>
      </div>
      <div class="form_item">
        <label>行业标签<span>*</span>：</label>
        <div class="form_input">
        <!-- <el-select v-model="form.industryArray" multiple placeholder="选择对应的行业标签(最多选择三个)" @change="industryArray(form.industryArray)">
          <el-option v-for="(item,index) in industryTagList" :key="index" :label="item.text" :value="item.value">
          </el-option>
        </el-select> -->
        <el-cascader
                  v-model="IndustryItems"
                  :options="industryTagList"
                  placeholder="选择对应的行业标签(最多选择三个)"
                  :props="props"
                  clearable
                  popper-class="article-industry-cascader"
                  @change="IndustryItem1"></el-cascader>
        </div>
      </div>
      <div class="form_item">
        <label>话题<span>*</span>：</label>
        <div class="form_input">
        <el-input class="theme_input" v-model="form.Topic" :disabled="!!relationId" :maxlength="20" placeholder="请输入话题(最多 20 个字)"></el-input>
        </div>
      </div>	
      <div class="btn_area">
        <el-button type="info" @click="submit">保存</el-button>
        <el-button type="info" @click="publish">发布</el-button>
        <el-button @click="back">取消</el-button>
      </div>
    </div>
    <div class="mobile-content" v-else>
      <div class="input-area">
        <input class="title-input" v-model="form.title" :maxlength="50" placeholder="请输入标题（建议3-31个字）"></input>
        <textarea class="textarea" type="textarea" resize="none" v-model="form.textContent" placeholder="请输入正文（建议100-2000个字）"></textarea>
        <el-upload
          class="upload-box"
          :action="uploadUrl"
          list-type="picture-card"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :limit="3"
          :on-remove="handleRemove">
          <i class="el-icon-plus"></i>
        </el-upload>
        <div class="tags-box">
          <div class="tags-item" @click="showTagsFilter('product')">
            <div class="left">
              <div class="title">
                <svg-icon icon-class="tags"></svg-icon>
                产品标签
              </div>
              <div class="tags">
                <div
                  class="tag"
                  v-for="item in displayProductTags"
                  :key="String(item.value)"
                  @click.stop="removeSelectedProductTag(item)"
                >
                  {{ item.text }}
                  <i class="el-icon-close"></i>
                </div>
              </div>
            </div>
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="tags-item" @click="showTagsFilter('industry')">
            <div class="left">
              <div class="title">
                <svg-icon icon-class="tags"></svg-icon>
                行业标签
              </div>
              <div class="tags">
                <div
                  class="tag"
                  v-for="item in displayIndustryTags"
                  :key="String(item.value)"
                  @click.stop="removeSelectedIndustryTag(item)"
                >
                  {{ item.text }}
                  <i class="el-icon-close"></i>
                </div>
              </div>
            </div>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="topic-text" v-if="form.Topic">
          #{{ form.Topic }}#
        </div>
        <van-popup v-model="filterPopupVisible" round position="bottom" @close="handlePopupClose">
          <div class="popup-box">
            <div class="popup-item" v-if="filterMode == 'product'">
              <div class="title">产品</div>
              <div class="tags">
                <div
                  class="tag"
                  v-for="item in productTagList"
                  :key="item.value"
                  :class="{ selected: selectedProductTags.some(tag => String(tag.value) === String(item.value)) }"
                  @click="handleClickProduct(item)"
                >{{ item.text }}</div>
              </div>
            </div>
            <div class="popup-item" v-else-if="filterMode == 'industry'">
              <template v-for="item in industryTagList">
                <div class="title">{{ item.text }}</div>
                <div class="tags">
                  <div
                    class="tag"
                    v-for="tag in item.list"
                    :key="tag.value"
                    :class="{ selected: selectedIndustryTags.some(selected => String(selected.value) === String(tag.value)) }"
                    @click="handleClickIndustry(item, tag)"
                  >{{ tag.text }}</div>
                </div>
              </template>
            </div>
            <div class="popup-btn-box">
              <div class="btn" @click="handleClickFilterClear">重置</div>
              <div class="btn cur" @click="handleClickFilterConfirm">确定</div>
            </div>
          </div>
        </van-popup>
      </div>
      <div class="content-btn">
        <div class="confirm-btn" @click="publish">发布</div>
      </div>
    </div>
  </div>
</template>

<script>
  import Headers from '@/components/header.vue';
  import * as forum from '../../api/forum.js';
  import * as Fence from "@/api/library.js";
  import WEditor  from '@/components/WEditor/Index.vue'
  import { debounce } from "@/utils/common";
  import { dataState } from "@/api/all.js";
  import { E3DCourse} from '@/api/E3D.js'
  import { ApiToken } from '@/utils/ApiToken'
  import { mapState } from 'vuex'
  export default {
    name: "articles",
    components: {
      Headers,
      WEditor
    },
    computed: {
      ...mapState(['Module', 'Infos', 'token']),
      displayProductTags() {
        const values = Array.isArray(this.form.productArray) ? this.form.productArray : []
        return this.productTagList.filter(item =>
          values.some(value => String(value) === String(item.value))
        )
      },
      displayIndustryTags() {
        const ids = Array.isArray(this.form.industrySecondArray) ? this.form.industrySecondArray : []
        return this.selectedIndustryTags.filter(item =>
          ids.some(value => String(value) === String(item.value))
        )
      },
      hmiChinaProductId() {
        const fromModule = parseInt(this.Module && this.Module.hmiChinaProductId, 10)
        if (fromModule > 0) return String(fromModule)
        const fromQuery = this.$route.query.productId
        if (fromQuery) return String(fromQuery)
        return String(ApiToken.hmiChinaProductId || '')
      },
      hasHmiAccess() {
        if (!this.token || !this.Infos) return false
        return !!(this.Infos.isHmiTrial || String(this.Infos.partnerType) === '10852')
      },
      isHmiForumPost() {
        const id = this.hmiChinaProductId
        if (!id) return false
        return (this.form.productArray || []).map(String).includes(id)
      },
      isPc(){
        return this.$store.state.clientWidth > 768
      },
      uploadUrl() {
        return ApiToken.baseApi + '/Files/UploadAzureBlob'
      }
    },
    watch: {
      '$route'() {
        this.initPage()
      },
    },
    created() {
      // 数据统计
      const data ={
        "visitType": 1,
        "gid": sessionStorage.getItem('gid') ? sessionStorage.getItem('gid') : '',
        "url": window.location.href,
        "pageUrl": '我要提问',
        "relationId": ""
      }
      dataState(data).then(res => {
        sessionStorage.setItem('gid',res.data);
      })
      this.initPage()
    },
    data() {
      return {
        props: { multiple: true, value: 'value', label: 'text', children: 'list' },
        IndustryItems: [],     // !行业多选
        config: {
          initialFrameHeight: 360,
          scaleEnabled: true,
          UEDITOR_HOME_URL: 'ueditor/'
        },
        screenWidth: document.body.clientWidth,
        form: {
          "id": "",
          "title": "",
          "Introduction": '',
          "textContent": "",
          "productBaseId": 0,
          "productArray": [],
          "industryArray": [],
          "industrySecondArray": [],
          "Topic": '',
          imageUrls: []
        },
        industryTagList: [],
        productTagList: [],
        type: 0,
        relationId: null,
        topic: '',
        uploadList: [],
        filterPopupVisible: false,
        filterMode: 'product',
        selectedProductTags: [],
        selectedIndustryTags: [],
      };
    },
    methods: {
      initPage() {
        this.type = this.$route.query.type == 1 ? 1 : this.$route.query.type == 2 ? 2 : 0;
        this.compe = this.$route.query.compe || 0;
        this.relationId = this.$route.query.relationId || null;
        if (this.relationId) {
          if (this.type == 2) {
            this.getE3DInit(this.relationId)
          } else {
            this.getInit(this.relationId)
          }
        } else {
          this.topic = ''
          this.form.Topic = ''
        }
        this.$emit('change', 1, '写文章')
        this.$nextTick(() => {
          this.getProduct()
        })
      },
      getInit(relationId){
        const id = { id: relationId };
        Fence.GetDetails(id).then((res) => {
          if (res.status == -100) {
            this.topic = ''
            this.form.Topic = ''
            this.relationId=''
            return false;
          
          }
          this.topic = res.data.title;
          this.form.Topic = res.data.title;
        });
      },
      // 获取E3D视频详情
      getE3DInit(relationId){
        const id = { id: relationId };
        E3DCourse(id).then((res) => {
          if (res.status == -100) {
            return false;
          }
          this.topic = res.data.title;
          this.form.Topic = res.data.title;
        });
      },

      IndustryItem1(){
        if(this.IndustryItems.length > 3){
          this.$toast('行业标签最多同时选择三个！')
          this.IndustryItems = this.IndustryItems.slice(0, 3)
        }
        var arr = []
        var arr_children = []
        this.IndustryItems.forEach(item => {
          arr.push(item[0])
          arr_children.push(item[1])
        })
        this.form.industryArray = [...new Set(arr)]
        this.form.industrySecondArray = arr_children
      },
      ueReady() {
        window.ue.setContent(this.form.textContent)
      },
      getData() {
        forum.getDetails({
          "forumId": this.$route.query.id
        }).then(res => {
          if (res.status == 1) {
            // const parseJsonArray = (val) => {
            // 	if (!val) return []
            // 	try {
            // 		const parsed = JSON.parse(val)
            // 		return Array.isArray(parsed) ? parsed : []
            // 	} catch (e) {
            // 		return []
            // 	}
            // }
            this.form = {
              "id": this.$route.query.id,
              "title": res.data[0].title,
              "Introduction": res.data[0].introduction,
              "textContent": res.data[0].textContent,
              "productBaseId": 0,
              "productArray": JSON.parse(res.data[0].product),
              "industryArray": JSON.parse(res.data[0].industry),
              "industrySecondArray": JSON.parse(res.data[0].industrySecond),
              "Topic": res.data[0].topic
              // "productArray": parseJsonArray(res.data[0].product),
              // "industryArray": parseJsonArray(res.data[0].industry),
              // "industrySecondArray": parseJsonArray(res.data[0].industrySecond),
              // "Topic": res.data[0].topic || ''
            }
            this.syncSelectedProductTags()
            this.type = res.data[0].type
            this.relationId = res.data[0].relationId
            
            var industry = JSON.parse(res.data[0].industrySecond)
            var IndustryList = []
                  this.industryTagList.filter(item => {
                      item.list.filter(val => {
                        if(industry.indexOf(val.value) > -1){
                            IndustryList.push([item.value, val.value])
                        }
                      })
                  })
                  this.IndustryItems = IndustryList
            const setContent = document.querySelector(".w-e-text");
            setContent.innerHTML = this.form.textContent;
          }
        })
      },
      //  !行业标签多选超出提示
      industryArray(val){
        if (val.length > 3) {
          this.$toast('行业标签最多同时选择三个！')
          val.pop();
        }
      },
      getProduct() {
        forum.getProduct().then(res => {
          if (res.status == 1) {
            let productList = [];
            res.data.products.map(item =>{
              if(item.extend2 == '' || item.extend2 == '驭剑'){
                productList = productList.concat(item.list);
                return productList
              }
            })
            // 无 HMI 身份时不展示「HMI 中国版」产品标签
            const hmiId = this.hmiChinaProductId
            if (hmiId && !this.hasHmiAccess) {
              productList = productList.filter(item => String(item.value) !== String(hmiId))
            }
            this.productTagList = productList;
            this.industryTagList = res.data.industrys
            this.syncSelectedProductTags()
            this.$nextTick(() => {
              if(this.$route.query.id){
                this.getData()
              } else {
                this.applyDefaultProduct()
              }
            })
            
          }
        })
      },
      syncSelectedProductTags() {
        const selectedValues = Array.isArray(this.form.productArray) ? this.form.productArray : []
        this.selectedProductTags = this.productTagList.filter(item =>
          selectedValues.some(value => String(value) === String(item.value))
        )
      },
      normalizeTagValues(values) {
        return Array.isArray(values) ? values : []
      },
      getSelectedIndustryTagObjects() {
        const selectedSecondValues = this.normalizeTagValues(this.form.industrySecondArray)
        const selectedFirstValues = this.normalizeTagValues(this.form.industryArray)
        const selectedValues = [...new Set([...selectedFirstValues, ...selectedSecondValues])]
        const result = []
        this.industryTagList.forEach(group => {
          group.list.forEach(tag => {
            if (selectedValues.some(value => String(value) === String(tag.value))) {
              result.push({
                ...tag,
                parentText: group.text,
                parentValue: group.value
              })
            }
          })
        })
        return result
      },
      syncSelectedTags(mode) {
        if (mode === 'product') {
          this.syncSelectedProductTags()
          return
        }
        if (mode === 'industry') {
          this.selectedIndustryTags = this.getSelectedIndustryTagObjects()
        }
      },
      updateConfirmedTagSelection(mode, selectedTags) {
        if (mode === 'product') {
          this.form.productArray = selectedTags.map(item => item.value)
          this.selectedProductTags = selectedTags
          return
        }
        if (mode === 'industry') {
          this.form.industrySecondArray = selectedTags.map(item => item.value)
          this.form.industryArray = [...new Set(selectedTags.map(item => item.parentValue))]
          this.selectedIndustryTags = selectedTags
        }
      },
      // 按产品 Id 默认选中（如 HMI 页带入的 productId）；仅当选项中存在且具备 HMI 身份时生效
      applyDefaultProduct() {
        if (this.$route.query.id) return
        const productId = this.$route.query.productId
        if (!productId) return
        if (!this.hasHmiAccess) return
        const idStr = String(productId)
        const exists = this.productTagList.some(item => String(item.value) === idStr)
        if (!exists) return
        if (!this.form.productArray.map(String).includes(idStr)) {
          this.form.productArray = [idStr]
        }
        this.syncSelectedProductTags()
      },
      // !发布文章
      publish(){
        // 触屏端简介兼容
        if(!this.isPc) {
          if (!this.form.Introduction) {
            this.form.Introduction = this.form.textContent.slice(0, 99)
          }
        }
        console.log()
        if(!this.form.title){
          this.$toast({message: '请填写标题',duration: 1000,})
          return
        }
        if(!this.form.Introduction){
          this.$toast({message: '请填写简介',duration: 1000,})
          return
        }
        if(!this.form.textContent){
          this.$toast({message: '请填写正文',duration: 1000,})
          return
        }
        if(this.form.productArray.length == 0){
          this.$toast({message: '请选择产品标签',duration: 1000,})
          return
        }
        if(this.form.industryArray.length == 0){
          this.$toast({message: '请选择行业标签',duration: 1000,})
          return
        }
        if(!this.form.Topic && this.isPc){
          this.$toast({message: '请填写话题',duration: 1000,})
          return
        }
        this.form.imageUrls = this.uploadList.map(item => {
          return item.response.data.fileUrl
        }).join(',')
        const obj = {
          ...this.form,
          type: this.type,
          relationId: this.relationId
        }
        debounce(()=>{
          forum.savePublish(obj).then(res => {
            this.$toast({message: res.message,duration: 1000,})
            if(res.status == 1){
              // this.$router.push('/home/forum')
              this.back()
            }
          })
        },2000)
      },
      submit() {
        if(!this.form.title){
          this.$toast({message: '请填写标题',duration: 1000,})
          return
        }
        if(!this.form.Introduction){
          this.$toast({message: '请填写简介',duration: 1000,})
          return
        }
        if(!this.form.textContent){
          this.$toast({message: '请填写正文',duration: 1000,})
          return
        }
        if(this.form.productArray.length == 0){
          this.$toast({message: '请选择产品标签',duration: 1000,})
          return
        }
        if(this.form.industryArray.length == 0){
          this.$toast({message: '请选择行业标签',duration: 1000,})
          return
        }
        if(!this.form.Topic){
          this.$toast({message: '请填写话题',duration: 1000,})
          return
        }
        const obj = {
          ...this.form,
          type: this.type,
          relationId: this.relationId
        }
        debounce(()=>{
          if (this.$route.query.id) {
            forum.editArticle(obj).then(res => {
              this.$toast({message: res.message,duration: 1000,})
              if(res.status == 1){
                this.cancel()
              }
            })
          } else {
            forum.saveForum(obj).then(res => {
              this.$toast({message: res.message,duration: 1000,})
              if(res.status == 1){
                this.cancel()
              }
            })
          }
        },2000)
      },
      cancel() {
        this.form = {
          "id": "",
          "title": "",
          "Introduction": '',
          "textContent": "",	
          "productBaseId": 0,
          "productArray": [],
          "industryArray": [],
          "industrySecondArray": [],
          "Topic": ''
        }
        if(this.relationId){
          this.form.Topic = this.topic
        }
        this.IndustryItems = []
        const setContent = document.querySelector(".w-e-text");
        setContent.innerHTML = "";
      },
      back() {
        // HMI 中国版相关帖：回到 Forum 问答入口，并默认打开 HMI Tab
        if (this.isHmiForumPost) {
          this.$router.push("/home/forum?article=question&tab=hmi")
          return
        }
        if (this.type == 1) {
          this.$router.push("/home/forum?article=question")
          return
        }
        if (this.type==2){
          this.$router.push("/home/forum?article=hmtion")
          return
        }
        this.$router.push("/home/forum")
      },
      // 上传图片
      handleAvatarSuccess(res, file, fileList) {
        // console.log(res)
        // console.log(fileList)
        this.uploadList = fileList
        // this.imageUrl = URL.createObjectURL(fi le.raw);
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type.startsWith('image/');
        const isLt2M = file.size / 1024 / 1024 < 5;

        if (!isJPG) {
          this.$toast({message: res.message,duration: 1000,})
          this.$message.error('请上传图片格式');
        }
        if (!isLt2M) {
          this.$toast({message: '上传图片大小不能超过 5MB',duration: 1000,})
        }
        return isJPG && isLt2M;
      },
      handleRemove(file, fileList) {
        // console.log(file, fileList);
        this.uploadList = fileList
      },
      showTagsFilter(mode) {
        if(!mode) return
        this.filterMode = mode
        this.syncSelectedTags(mode)
        this.filterPopupVisible = true
      },
      handlePopupClose() {
        this.syncSelectedTags(this.filterMode)
      },
      removeSelectedProductTag(item) {
        if (!item) return
        const itemValue = String(item.value)
        this.selectedProductTags = this.selectedProductTags.filter(tag => String(tag.value) !== itemValue)
        this.form.productArray = this.selectedProductTags.map(tag => tag.value)
      },
      removeSelectedIndustryTag(item) {
        if (!item) return
        const itemValue = String(item.value)
        this.selectedIndustryTags = this.selectedIndustryTags.filter(tag => String(tag.value) !== itemValue)
        this.form.industrySecondArray = this.selectedIndustryTags.map(tag => tag.value)
        this.form.industryArray = [...new Set(this.selectedIndustryTags.map(tag => tag.parentValue))]
      },
      handleClickProduct(item) {
        if (!item) return
        const itemValue = String(item.value)
        const hasItem = this.selectedProductTags.some(tag => String(tag.value) === itemValue)

        if (hasItem) {
          this.selectedProductTags = this.selectedProductTags.filter(tag => String(tag.value) !== itemValue)
        } else {
          this.selectedProductTags.push(item)
        }
      },
      handleClickIndustry(item, tag) {
        if (!item || !tag) return
        const selectedItem = {
          ...tag,
          parentText: item.text,
          parentValue: item.value
        }
        const itemValue = String(tag.value)
        const hasItem = this.selectedIndustryTags.some(selected => String(selected.value) === itemValue)

        if (hasItem) {
          this.selectedIndustryTags = this.selectedIndustryTags.filter(selected => String(selected.value) !== itemValue)
          return
        }

        if (this.selectedIndustryTags.length >= 3) {
          this.$toast('行业标签最多同时选择三个！')
          return
        }

        this.selectedIndustryTags.push(selectedItem)
      },
      handleClickFilterClear() {
        if (this.filterMode === 'product') {
          this.selectedProductTags = []
          return
        }
        this.selectedIndustryTags = []
      },
      handleClickFilterConfirm() {
        if (this.filterMode === 'product') {
          this.updateConfirmedTagSelection('product', this.selectedProductTags)
        } else if (this.filterMode === 'industry') {
          this.updateConfirmedTagSelection('industry', this.selectedIndustryTags)
        }
        this.filterPopupVisible = false
      },
    }
  };
</script>

<style lang="scss" scoped>
  $mobil_base: 750;

  @function vw($true) {
    @return ($true / $mobil_base) * 100vw;
  }
  .el-cascader-menu:nth-child(even) {
      .el-checkbox {
          width: 100%;
          height: 100%;
          z-index: 10;
          position: absolute;
      }
    .el-cascader-node__label{
        margin-left: 10px;
      }
    .el-scrollbar__bar {
          opacity: 0 !important;
      }
    }
  .el-scrollbar {
      .el-scrollbar__bar {
          opacity: 1 !important;
      }
    }
    
  .article_page {
    .article_content { padding: 15px 40px 40px;border: 1px solid #E6E6E6;
      .article-explain {margin:0 0 20px 46px}
      .form_item{
        margin: 0 0 20px 0;display: flex;
        label{
          font-size: 16px;color: #545454;width: 100px;text-align: right;line-height: 40px;
          span{color:#f60000;}
        }
        .form_input{
          width: calc( 100% - 100px );
        }
      }
      /deep/ .w_editor {
        position: relative;
        z-index: 1;
      }
      .el-cascader{ width: 100%; }
      /deep/ .el-input.title_input {
        width: 100%;
        height: 40px !important;
        line-height: 40px !important;

        input {
          height: 40px !important;
          line-height: 40px !important;
        }
      }
      
      /deep/ .el-textarea.introduction_input{
        font-size: 16px;
      }
      

      /deep/ .el-select {
        width: 100%;
        min-height: 30px;
        border-radius: 0;

        .el-input {
          input {
            font-size: 16px;
            color: #545454;
          }
          .el-input__icon{
            line-height: 30px;
          }
        }
      }
      
      /deep/ .el-input.theme_input {
        width: 100%;
        height: 30px !important;
        line-height: 30px !important;
      
        input {
          font-size: 16px;
          color: #545454;
        }
      }

      .btn_area {
        margin-top: 140px;
        display: flex;
        justify-content: flex-end;

        /deep/ .el-button {
          width: 156px;
          height: 36px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 0;

          span {
            font-size: 16px;
          }

          &:first-of-type {
            background: #6B18A8;
          }
          &:nth-of-type(2) {
            background: #6B18A8;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .article_page {
      margin: vw(24) 0 0;
      min-height: 70vh;
      .article_content {
        padding: vw(22);
        border: none;
        background-color: #fff;
        .article-explain {margin: 0; margin-bottom: 10px;}
        .form_item{
          margin: 0 0 vw(20) 0;
          label{
            font-size: vw(24);
            width: vw(144);
          }
          &:first-of-type{
            label{
              line-height: vw(60);
            }
          }
          &:nth-of-type(2){
            label{
              padding: vw(16) 0 0 0;
            }
          }
          &:nth-of-type(3){
            label{
              padding: vw(16) 0 0 0;
            }
          }
          &:nth-of-type(4){
            label{
              line-height: vw(70);
            }
          }
          &:nth-of-type(5){
            label{
              line-height: vw(70);
            }
          }
          &:nth-of-type(6){
            label{
              line-height: vw(70);
            }
          }
          .form_input{
            width: calc( 100% - 72px );
          }
        }
      
        /deep/ .el-input.title_input {
          height: vw(60) !important;
          line-height: vw(60) !important;
      
          input {
            height: vw(60) !important;
            line-height: vw(60) !important;
            font-size: vw(24);
          }
        }
        
        /deep/ .el-textarea.introduction_input{
          font-size: vw(24);
        }
      
        /deep/ .el-select {
      
          .el-input {
            height: auto !important;
            input {
              font-size: vw(24);
            }
            .el-input__icon{
              line-height: vw(70);
            }
          }
        }
        /deep/ .el-input.theme_input {
          height: vw(70) !important;
          line-height: vw(70) !important;
              
          input {
            height: vw(70) !important;
            line-height: vw(70) !important;
            font-size: vw(24);
          }
        }
      
        .btn_area {
          margin-top: vw(240);
          justify-content: center;
      
          /deep/ .el-button {
            width: vw(200);
            height: vw(66);
      
            span {
              font-size: vw(24);
            }
      
            &:first-of-type {
              background: #6B18A8;
            }
      
            &:nth-of-type(2) {
              background: #6B18A8;
            }
          }
        }
      }
      .mobile-content{
        .input-area{
          padding: vw(22);
          border: none;
          background-color: #fff;
        }
        .title-input{
          width: 100%;
          outline: none;
          border: none;
          color: #000;
          font-size: vw(28);
          line-height: vw(40);
        }
        .textarea{
          border: none;
          width: 100%;
          outline: none;
          font-size: vw(24);
          line-height: vw(40);
          color: #000;
          margin: vw(14) 0;
          height: vw(200);
        }
        .tags-box{
          margin-top: vw(40);
        }
        .tags-item{
          display: flex;
          align-items: center;
          &+.tags-item{
            margin-top: vw(30);
          }
          >.left{
            flex: 1;
            flex-shrink: 0;
            >.title{
              display: flex;
              align-items: center;
              gap: vw(10);
              color: #000;
              font-size: vw(24);
            }
            >.tags{
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              gap: vw(10);
              margin-top: vw(12);
              >.tag{
                display: flex;
                align-items: center;
                gap: vw(18);
                background-color: #EDEDED;
                border-radius: vw(8);
                padding: 0 vw(14);
                line-height: vw(36);
                font-size: vw(20);
                color: #363d42;
              }
            }
          }
        }
        .content-btn{
          display: flex;
          align-items: center;
          justify-content: center;
          margin: vw(100) 0;
          >.confirm-btn{
            display: flex;
            align-items: center;
            justify-content: center;
            height: vw(76);
            width: vw(240);
            background-color: #6B18A8;
            color: #fff;
            font-weight: bold;
            font-size: vw(24);
          }
        }
        
      }
    }
    .upload-box{
      background-color: #fff;
      max-height: vw(210);
      overflow: hidden;
      /deep/ .el-upload-list__item, /deep/ .el-upload--picture-card {
        height: vw(200);
        width: vw(200);
      }
      /deep/ .el-upload--picture-card{
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
      /deep/ .el-upload-list--picture-card .el-progress, /deep/ .el-progress-circle{
        height: 100% !important;
        width: 100% !important;
      }
    }
    .popup-box{
      padding: vw(50);
      padding-bottom: vw(150);
      .popup-item{
        max-height: 65vh;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: vw(20);
        margin-bottom: vw(40);
        >.title{
          color: #363D42;
          font-size: vw(24);
          font-weight: bold;
        }
        >.tags{
          display: flex;
          align-items: center;
          gap: vw(28);
          flex-wrap: wrap;
          >.tag{
            display: flex;
            align-items: center;
            height: vw(36);
            background-color: #ededed;
            color: #363D42;
            border-radius: vw(8);
            padding: 0 vw(20);
            font-size: vw(20);
            &.selected{
              background-color: #f4e3ff;
              color: #6B04A8;
            }
          }
        }
      }
      .popup-btn-box{
        margin-top: vw(60);
        display: flex;
        align-items: center;
        gap: vw(26);
        >.btn{
          flex: 1;
          text-align: center;
          height: vw(72);
          line-height: vw(72);
          background-color: #ededed;
          font-size: vw(24);
          font-weight: 500;
          border-radius: vw(8);
          color: #000;
          &.cur{
            background-color: #6B04A8;
            color: #fff;
          }
        }
      }
    }
    .topic-text{
      margin-top: vw(20);
      font-size: vw(24);
      color: #6b18a8;
    }
  }
</style>
<style>
  .article-industry-cascader {
    z-index: 10001 !important;
  }
  #tinymce p {white-space: nowrap!important;}
  #edui1_bottombar{display: none!important;}
  .mce-container, .mce-container *, .mce-widget, .mce-widget *, .mce-reset {white-space: normal!important;}
  .mce-statusbar{display: none!important;}
  .mce-reset{width: 100%!important;}
  .mce-txt{display: inline-block;min-width: 40px;text-align: center!important;}
</style>
